<template>
  <AnalyticsWidget
    title="Production summary"
    subTitle="Production summary for today"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight"
    >
    <div class="p-2">
      <LoadingPanel :loading="loading" />
      <div v-if="!loading">
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Panels Pending Production"
              :value="summaryData.panelsPendingProduction">
              {{formatInteger(summaryData.panelsPendingProduction)}}
              <template v-slot:info>Total panels that are pending production</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Meterage Pending Production"
              :value="summaryData.panelAreaPendingProduction">
              {{formatDecimal(summaryData.panelAreaPendingProduction, 2, true)}}m&sup2;
              <template v-slot:info>Total square metres of panels that are pending production</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Panels Started Production"
              :value="summaryData.panelsStartedProduction">
              {{formatInteger(summaryData.panelsStartedProduction)}}
              <template v-slot:info>Total panels that started production today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Meterage Started Production"
              :value="summaryData.panelAreaStartedProduction">
              {{formatDecimal(summaryData.panelAreaStartedProduction, 2, true)}}m&sup2;
              <template v-slot:info>Total square metres of panels that started production today</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
        <AnalyticsDashboardValueRow>
          <div class="col">
            <AnalyticsDashboardValue
              title="Panels Completed Production"
              :value="summaryData.panelsCompletedProduction">
              {{formatInteger(summaryData.panelsCompletedProduction)}}
              <template v-slot:info>Total panels that completed production today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Meterage Completed Production"
              :value="summaryData.panelAreaCompletedProduction">
              {{formatDecimal(summaryData.panelAreaCompletedProduction, 2, true)}}m&sup2;
              <template v-slot:info>Total square metres of panels that completed production today</template>
            </AnalyticsDashboardValue>
          </div>        
          <div class="col">
            <AnalyticsDashboardValue
              :title="`Total Days ${summaryData.totalDaysBehindAvg >= 0 ? 'Behind' : 'Ahead'} Average`"
              :value="summaryData.totalDaysBehindAvg">
              {{formatDecimal(summaryData.totalDaysBehindAvg)}}
              <template v-slot:info>Based on pending production stages or stages completed today</template>
            </AnalyticsDashboardValue>
          </div>
          <div class="col">
            <AnalyticsDashboardValue
              title="Panels Recut"
              :value="summaryData.panelsRecut">
              {{formatInteger(summaryData.panelsRecut)}}
              <template v-slot:info>Total panels requiring a recut today</template>
            </AnalyticsDashboardValue>
          </div>
        </AnalyticsDashboardValueRow>
      </div>
    </div>
  </AnalyticsWidget>
</template>


<script>
import _ from 'lodash'
import moment from 'moment'

import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsDashboardValue from '@/modules/intelligence/components/analyticsDashboardValue'
import AnalyticsDashboardValueRow from '@/modules/intelligence/components/analyticsDashboardValueRow'

export default {
  name: 'ProductionSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsDashboardValue,
    AnalyticsDashboardValueRow
  },
  props: {
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
  },
  data() {
    return {
      loading: true,
      summaryData: {},
    }
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/production/panelschedule', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/production/panelschedule')
  },
  methods: {
    requestData() {

      this.$apiService.analyticsService.getProductionSummary()
      .then(response => {
        this.summaryData = response.data
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
    },
    
  }
}
</script>